import type { SpotQueueStage, SpotQueueStageFilter } from '@myrewards/contracts';
import type { StatusTone } from '../ui';

/**
 * APP-226: each stage in plain words (Tom: "show where they're at in the system"), with a tone that
 * always comes with its word. Waiting on the manager with no one to decide is a problem to fix.
 * All Spot awards and (APP-232) Home's Spot awards in progress both say them this way, so Home
 * reads them here without loading the Spot pages. APP-233: a decision held by funding says who
 * holds it, as Waiting on does (Tom: the badge "should say what's actually blocking"). APP-252: the
 * letter stage reads as the canvas's S9 chip, "Letter to review", since the Stock Admin team checks
 * a letter MyRewards has already made (APP-244); before, "Approved, letter being made". APP-254 D1:
 * its tone is the canvas's amber, waiting, since the letter waits for the Stock Admin team to claim
 * and check it, as the queue's "Waiting for a claim" does. [default] The other stages keep their
 * tones where S9 draws them otherwise: the canvas's own boards disagree (S2 draws the committee's
 * wait amber, S4 the manager's), and green is Paid's, not Payroll's before it pays.
 */
export const QUEUE_STAGE: Readonly<Record<SpotQueueStage, { label: string; tone: StatusTone }>> = {
  committee: { label: 'With the committee', tone: 'waiting' },
  funding: { label: 'Waiting on the Executives (funding)', tone: 'waiting' },
  manager: { label: 'Waiting on the manager', tone: 'waiting' },
  no_manager: { label: 'No manager set (needs a supervisor)', tone: 'problem' },
  letter: { label: 'Letter to review', tone: 'waiting' },
  released: { label: 'Letter released', tone: 'info' },
  payroll: { label: 'With Payroll', tone: 'info' },
  paid: { label: 'Paid', tone: 'done' },
  closed: { label: 'Closed', tone: 'done' },
  not_awarded: { label: 'Not awarded', tone: 'neutral' },
  cancelled: { label: 'Cancelled', tone: 'neutral' },
};

/**
 * APP-233: the Stage filter's choices. In progress (the default) is Home's card's rule: every stage
 * but Closed, Not awarded and Cancelled.
 */
export const STAGE_FILTER: Readonly<Record<SpotQueueStageFilter, string>> = {
  in_progress: 'In progress',
  all: 'Every stage',
  ...(Object.fromEntries(
    Object.entries(QUEUE_STAGE).map(([id, stage]) => [id, stage.label]),
  ) as Record<SpotQueueStage, string>),
};
